import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Header from '../components/header';
import Footer from '../components/footer';
export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
